const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  debug: (...args: any[]) => { if (isDev) console.log(...args); },
  warn: (...args: any[]) => { if (isDev) console.warn(...args); },
  error: (msg: string) => { console.error(msg); },
};
